module.exports = __webpack_public_path__ + "img/douyinhao.ab1996ea.png";